export class Item {
    constructor(template) {
        this.itemElement = template.content
            .querySelector(".todo-item")
            .cloneNode(true);
        this.title = this.itemElement.querySelector(".todo-item__text");
        this.copyButton = this.itemElement.querySelector(".todo-item__copy");
        this.deleteButton = this.itemElement.querySelector(".todo-item__del");
        this.editButton = this.itemElement.querySelector(".todo-item__edit");
    }
    set id(value) {
        this._id = value;
    }
    get id() {
        return this._id || "";
    }
    set name(value) {
        this.title.textContent = value;
    }
    get name() {
        return this.title.textContent || "";
    }
    setCopyHandler(handleCopyItem) {
        this.handleCopyItem = handleCopyItem;
        this.copyButton.addEventListener("click", (evt) => {
            this.handleCopyItem(this);
        });
    }
    setDeletedHandler(handleDeleteItem) {
        this.handleDeleteItem = handleDeleteItem;
        this.deleteButton.addEventListener("click", (evt) => {
            this.handleDeleteItem(this);
        });
    }
    setEditHandler(handleEditItem) {
        this.handleEditItem = handleEditItem;
        this.editButton.addEventListener("click", (evt) => {
            this.handleEditItem(this);
        });
    }
    render(item) {
        this.name = item.name;
        this.id = item.id;
        return this.itemElement;
    }
}
